<div class="container">
  <h1 class="page-title"><span class="icon"><i class="fas fa-truck"></i></span>{{ 'ImportDeclarationHeaderDetail.Header' | translate }} ({{importHeader?.importDeclarationNo}}) </h1>
  <p-card>
      <form class="detail-form">
        <div class="field grid">
          <div class="p-fluid field grid">
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ImportDeclarationHeaderDetail.ImportNum' | translate }}</label>
              <div class="col-8 column-value">
                {{ importHeader?.importDeclarationNo | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ImportDeclarationHeaderDetail.Forwarder' | translate }}</label>
              <div class="col-8 column-value">
                {{ importHeader?.forwarder | optionsMapping:forwarderOptions | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ImportDeclarationHeaderDetail.PayeeType' | translate }}</label>
              <div class="col-8 column-value">
                {{ importHeader?.billObjectType | optionsMapping:billObjectTypeOptions | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ImportDeclarationHeaderDetail.Payee' | translate }}</label>
              <div class="col-8 column-value">
                {{ importHeader?.billObject | optionsMapping:billObjectOptions | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ImportDeclarationHeaderDetail.Company' | translate }}</label>
              <div class="col-8 column-value">
                {{ importHeader?.orgId | optionsMapping:orgIdOptions | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ImportDeclarationHeaderDetail.BillCorp' | translate }}</label>
              <div class="col-8 column-value">
                {{ importHeader?.billCorp | optionsMapping:billCorpOptions | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ImportDeclarationHeaderDetail.ReceiptFormNum' | translate }}</label>
              <div class="col-8 column-value">
                {{ importHeader?.whNo | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ImportDeclarationHeaderDetail.IdentificaitonNum' | translate }}</label>
              <div class="col-8 column-value">
                {{ importHeader?.docNo | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ImportDeclarationHeaderDetail.PaymentApplicationNum' | translate }}</label>
              <div class="col-8 column-value">
                {{ importHeader?.apInvoiceId | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ImportDeclarationHeaderDetail.APCreationDate' | translate }}</label>
              <div class="col-8 column-value">
                {{ importHeader?.apglDt | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ImportDeclarationHeaderDetail.TradeTerm' | translate }}</label>
              <div class="col-8 column-value">
                {{ importHeader?.incoTerm | optionsMapping:incoTermOptions | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ImportDeclarationHeaderDetail.Supplier' | translate }}</label>
              <div class="col-8 column-value">
                {{ importHeader?.vendor | optionsMapping:vendorOptions | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ImportDeclarationHeaderDetail.DeclarationDate' | translate }}</label>
              <div class="col-8 column-value">
                {{ importHeader?.importDt | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ImportDeclarationHeaderDetail.CustomsDeclarationMethod' | translate }}</label>
              <div class="col-8 column-value">
                {{ importHeader?.importType | optionsMapping:importTypeOptions | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ImportDeclarationHeaderDetail.HAWB' | translate }}</label>
              <div class="col-8 column-value">
                {{ importHeader?.expressBill | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ImportDeclarationHeaderDetail.MAWB' | translate }}</label>
              <div class="col-8 column-value">
                {{ importHeader?.mawbNo | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ImportDeclarationHeaderDetail.DeclarationType' | translate }}</label>
              <div class="col-8 column-value">
                {{ importHeader?.docType | optionsMapping:docTypeOptions | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ImportDeclarationHeaderDetail.RFQCurrency' | translate }}</label>
              <div class="col-8 column-value">
                {{ importHeader?.currency | optionsMapping:currencyOptions | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ImportDeclarationHeaderDetail.ExportCountryCode' | translate }}</label>
              <div class="col-8 column-value">
                {{ importHeader?.exportCountryCode | optionsMapping:countryOptions | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ImportDeclarationHeaderDetail.ExportCity' | translate }}</label>
              <div class="col-8 column-value">
                {{ importHeader?.exportCityCode | optionsMapping:cityOptions | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ImportDeclarationHeaderDetail.TaxBillNum' | translate }}</label>
              <div class="col-8 column-value">
                {{ importHeader?.gvTaxNo | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ImportDeclarationHeaderDetail.TaxBillDate' | translate }}</label>
              <div class="col-8 column-value">
                {{ importHeader?.gvTaxDt | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ImportDeclarationHeaderDetail.CustomsExchangeRate' | translate }}</label>
              <div class="col-8 column-value">
                {{ importHeader?.importRate | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ImportDeclarationHeaderDetail.CustomsAmount' | translate }}</label>
              <div class="col-8 column-value">
                {{ importHeader?.importAmount | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ImportDeclarationHeaderDetail.CustomsDutyTax' | translate }}</label>
              <div class="col-8 column-value">
                {{ importHeader?.importAmountTax | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ImportDeclarationHeaderDetail.CustomsDeclarationAntAC' | translate }}</label>
              <div class="col-8 column-value">
                {{ importHeader?.importAcctdAmount | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ImportDeclarationHeaderDetail.CustomsDutyTaxAC' | translate }}</label>
              <div class="col-8 column-value">
                {{ importHeader?.importAcctdAmountTax | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ImportDeclarationHeaderDetail.BusinessTaxBase' | translate }}</label>
              <div class="col-8 column-value">
                {{ importHeader?.estimatedGvAcctdAmount | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ImportDeclarationHeaderDetail.TaxAnt' | translate }}</label>
              <div class="col-8 column-value">
                {{ importHeader?.estimatedGvAcctdAmountTax | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ImportDeclarationHeaderDetail.TradePromotionFee' | translate }}</label>
              <div class="col-8 column-value">
                {{ importHeader?.estimatedGvAcctdExpBAmount | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ImportDeclarationHeaderDetail.ImportDutyTax' | translate }}</label>
              <div class="col-8 column-value">
                {{ importHeader?.estimatedGvAcctdExpCAmount | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ImportDeclarationHeaderDetail.CargoDutyTax' | translate }}</label>
              <div class="col-8 column-value">
                {{ importHeader?.estimatedGvAcctdExpDAmount | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ImportDeclarationHeaderDetail.Remarks' | translate }}</label>
              <div class="col-8 column-value">
                {{ importHeader?.reference | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ImportDeclarationHeaderDetail.CaseNum' | translate }}</label>
              <div class="col-8 column-value">
                {{ importHeader?.applyNo | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ImportDeclarationHeaderDetail.CreateBy' | translate }}</label>
              <div class="col-8 column-value">
                {{ importHeader?.createUser | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ImportDeclarationHeaderDetail.CreationTime' | translate }}</label>
              <div class="col-8 column-value">
                {{ importHeader?.createDt | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ImportDeclarationHeaderDetail.LastUpdateBy' | translate }}</label>
              <div class="col-8 column-value">
                {{ importHeader?.updateUser | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ImportDeclarationHeaderDetail.UpdateDt' | translate }}</label>
              <div class="col-8 column-value">
                {{ importHeader?.updateDt | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
              </div>
            </div>
          </div>
          <div class="grid">
            <div class="col">
              <button *ngIf="isShowEditBtn" pButton pRipple label="{{ 'Common.Button.Edit' | translate }}" (click)="goToEdit($event)" class="mr-2"></button>
              <button *ngIf="isShowConfirmBtn" pButton pRipple label="{{ 'ImportDeclarationHeaderDetail.ImportConfirm' | translate }}" (click)="confirmBtnClick($event)" class="mr-2"></button>
              <button *ngIf="isShowCancelBtn" pButton pRipple label="{{ 'ImportDeclarationHeaderDetail.ImportCancel' | translate }}" (click)="cancelBtnClick($event)" class="mr-2 p-button-secondary"></button>
            </div>
          </div>
        </div>
      </form>
  </p-card>
</div>
